import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lms-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {
  constructor(public titleService: Title, public translate: TranslateService, private router: Router) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translate.instant('agents.label') + ' - ' + this.translate.instant('companyName'));
  }

  onCreateAdmin(): void {
    this.router.navigate(['/agents/new']);
  }
}
